import React from 'react'
import { Spinner } from '@components/atoms'
import { BackofficeTheme } from '@components/systems/backoffice/BackofficeTheme'

import { useAppDispatch, authActions } from '@redux/index'

const AuthLoadingPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	React.useEffect(() => {
		reduxDispatch(authActions.TRIGGER_AUTH_LOADING_PAGE(true))
	}, [])

	return (
		<BackofficeTheme>
			<Spinner />
		</BackofficeTheme>
	)
}

export default AuthLoadingPage
